import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Body, RebirthHttpInterceptor } from 'rebirth-http';
import { EnvironmentService } from '../services/environment.service';
import { MockService } from '../services/mock.service';
import { UserInfoService } from '../services/user-info.service';
import { I18NService } from '../base-i18n/services/i18n.service';
import * as moment from 'moment';
import { LoginService } from 'src/app/layout/services/login.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LogoutRequest } from 'src/app/layout/interfaces/logout.interface';
import { UserTokenResponse } from 'base-shared';
import { Observable } from 'rxjs';
import {LogoutService} from "../../layout/services/logout.service";

@Injectable({
  providedIn: 'root',
})
export class DefaultGlobalInterceptor implements RebirthHttpInterceptor {

  exportType!: string;
  counter: number = 0;
  constructor(
    public userInfoService: UserInfoService,
    public mockService: MockService,
    private env: EnvironmentService,
    public i18nService: I18NService,
    private modalService: NzModalService,
    private loginService: LoginService,
    private logoutService: LogoutService,
    private router: Router,
    private cookieService: CookieService
  ) { }
  setExportHeaders(val: string): void {
    this.exportType = val;
  }

  request(req: HttpRequest<any>): HttpRequest<any> {
    const lang = _.isEmpty(this.i18nService.currentLang) ? 'en' : this.i18nService.currentLang.split('-')[0];

    setInterval(() => {
      if (sessionStorage.getItem('tokenExpiryTime') && sessionStorage.getItem('tokenExpiryDate')) {
        const tokenExpiryDate = moment(sessionStorage.getItem('tokenExpiryDate'));
        const nowDate = moment(new Date());
        const tenMinutes = 600;

        if (tokenExpiryDate.diff(nowDate, 'seconds') <= tenMinutes && this.counter === 0) {
          this.counter = 1;
          const json = {
            sessionKey: this.userInfoService.getUserToken()
          };

          const modalRef = this.modalService.create({
            nzTitle: "Session Expire Warning",
            nzContent: "Your session is about to expire. You will be automatically signed out. To continue please select Stay Signed In",
            nzWidth: 500,
            nzCancelText: "Logout",
            nzOnCancel: () => {
              const formBody = {
                token: this.userInfoService.getUserToken(),
                userName: this.userInfoService.getUserName(),
              };

              // Calling Logout API to clear session and cookies
              this.logoutService.logout(formBody)?.subscribe(
                (): void => {
                });
              this.userInfoService.setUserInfo({ photoPath: null });
              this.router.navigateByUrl('/login');
              this.cookieService.deleteAll(
                window.location.pathname,
                window.location.hostname
              );
              localStorage.clear();
              sessionStorage.clear()
            },
            nzClosable: false,
            nzMaskClosable: false,
            nzClassName: "logoutmodal",
            nzKeyboard: false,
            nzOkText: "Stay Signed In",
            nzOnOk: () => {
              this.loginService.getRefreshToken(json).subscribe((response: any) => {
                this.counter = 0;
                sessionStorage.setItem('tokenExpiryTime', JSON.stringify(response.expiresIn));
                sessionStorage.setItem('tokenExpiryDate', moment(new Date()).add(response.expiresIn, 'seconds').toString());
              });
            },
          })
        }
      }
    }, 50000);

    let h = new HttpHeaders({
      Accept: 'application/json',
      'Accept-Language': lang,
    });

    let uploadHeaders = new HttpHeaders({});
    let exportHeaders = new HttpHeaders({ Accept: this.exportType });

    const csrfToken = this.userInfoService.getCsrfToken();

    if (!_.isEmpty(csrfToken) && !req.url.includes('powerbi')) {
      h = h.append('X-XSRF-TOKEN', csrfToken);
      uploadHeaders = uploadHeaders.append('X-XSRF-TOKEN', csrfToken);
      exportHeaders = exportHeaders.append('X-XSRF-TOKEN', csrfToken);
    }

    const token = this.userInfoService.getUserToken();

    if (!_.isEmpty(token) && !req.url.includes('powerbi')) {
      h = h.append('Authorization', 'Bearer ' + token);
      uploadHeaders = uploadHeaders.append('Authorization', 'Bearer ' + token);
      exportHeaders = exportHeaders.append('Authorization', 'Bearer ' + token);
    }
    if ((req.url.endsWith('/logout') && !h.has('Authorization'))) {
      h = h.append('Authorization', 'Bearer ' + req.body['token']);
    }
    if( req.url.includes('powerbi')){
      const token = this.loginService.reportBearerToken;
      h = h.append('Authorization',token );
      uploadHeaders = uploadHeaders.append('Authorization', token);
      exportHeaders = exportHeaders.append('Authorization',token);
    }
    if (
      req.url.endsWith('/xml/upload') ||
      req.url.endsWith('container.xlsx') ||
      req.url.endsWith('vehicle.xls') ||
      req.url.endsWith('declaration.xml') ||
      req.url.endsWith('LPCORequest.xml') ||
      req.url.endsWith('/uploadContainerData') ||
      req.url.endsWith('/uploadVehicleData') ||
      req.url.endsWith('/uploadGoodsData') ||
      req.url.indexOf('/downloadBinary') > -1 || req.url.indexOf('/print') > -1 ||
      (req.url.indexOf('/export') > -1 && req.url.indexOf('/reports') === -1)||
      (req.url.indexOf('/export') > -1 && req.url.indexOf('/file')  > -1)||
      (req.url.indexOf('/attachment') > -1 &&
        req.url.indexOf('/bps') > -1 &&
        req.url.indexOf('/data') > -1) ||
      req.url.indexOf('/download') > -1 ||
      req.url.endsWith('/upload') ||
      (req.url.indexOf('/attachment') > -1 &&
        req.url.indexOf('/dms') > -1 &&
        req.url.indexOf('/upload') > -1) ||
      req.url.indexOf('upload/upload') > -1 ||
      req.url.indexOf('upload/update') > -1
    ) {
      const newReq = req.clone({
        headers:
          (req.url.indexOf('/export') > -1 || req.url.indexOf('/print') > -1) ? exportHeaders : uploadHeaders,
        responseType:
          req.url.endsWith('/upload') ||
            req.url.endsWith('/xml/upload') ||
            req.url.endsWith('/uploadContainerData') ||
            req.url.endsWith('/uploadGoodsData') ||
            req.url.endsWith('/uploadVehicleData') ||
            req.url.includes('/attachments/upload')
            ? 'json'
            : 'blob',
      });
      return newReq;
    } else {
      let newReq = req.clone({
        headers: h,
      });

      if (
        this.env.getEnvironment().mockData &&
        this.mockService.isMockUrlExists(req.url)
      ) {
        newReq = this.mockService.getMockRequest();
        newReq = newReq.clone({
          headers: h,
        });
      }
      return newReq;
    }
  }
}
